import React from "react";
import * as Styled from "./EmptyLiveStreams.styled";
import { CameraVideoOff } from "react-bootstrap-icons";
import { LayoutHeader } from "../layouts/LayoutHeader";

export const EmptyLiveStreams: React.FC<{
    showHeader?: boolean;
    isFiltered?: boolean;
}> = ({ showHeader = true, isFiltered = false }) => {
    return (
        <>
            {showHeader && <LayoutHeader title="Live Streams" hideSeeAll={true} itemCount={0} isLivestream={true} />}
            <Styled.Container>
                <Styled.ContentWrapper>
                    <Styled.IconWrapper>
                        <CameraVideoOff size={80} />
                    </Styled.IconWrapper>

                    <Styled.Title>{isFiltered ? "No Live Streams Match Your Filter" : "No Live Streams Available"}</Styled.Title>

                    <Styled.Message>
                        There are no live events streaming at the moment.
                        <br />
                        Check back soon for upcoming broadcasts!
                    </Styled.Message>

                </Styled.ContentWrapper>
            </Styled.Container>
        </>
    );
};
